<template>
    <el-timeline class="time-line-box">
        <el-timeline-item v-for="(v, i) in record5List" :key="i + 90000" :timestamp="v.addinfo2" type="primary" hollow placement="top">
            <el-card :body-style="{'padding': '10px'}">
                <div>
                    <h3 class="title-span">{{v.addinfo1}}</h3>
                </div>

                <div class="content-text">
                    <span>{{v.addremark1}}</span>
                </div>

                <div v-if="null != v.fileformatList && v.fileformatList.length > 0">
                    <el-row>
                        <el-col :span="8" v-for="(item, index) in v.fileformatList">
                            <div class="img-box">
                                <img :src="proxy.$ShopopeeUrl + item.filename" @click="emits('clickImg', proxy.$ShopopeeUrl + item.filename)">
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </el-timeline-item>
    </el-timeline>
</template>

<script setup>
    import {onMounted, getCurrentInstance} from "vue";

    const props = defineProps(["record5List"])
    const emits = defineEmits(["clickImg"])

    const { proxy } = getCurrentInstance()

    onMounted(() => {

    })

</script>

<style scoped>
    .time-line-box {
        text-align: left;
        padding-left: 5px;
        box-sizing: border-box;
        padding-right: 5px;
    }

    .time-line-content-box {
        padding: 5px;
    }

    .title-span {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .content-text {
        color: #606266;
        font-size: 14px;
        word-break: break-all;
        margin-bottom: 10px;
    }

    .img-box {
        width: 100%;
        padding-top: 100%;
        position: relative;
    }

    .img-box img {
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        left: 5px;
        top: 5px;
        position: absolute;
        object-fit: fill;
    }
</style>